import { REDIRECTED_PAYMENT_METHODS } from '../../constants';
import { getSelectedPaymentMethod } from '../../selectors/payment';
import { CheckoutState } from '../../state';

export const hasSelectedRedirectedPaymentMethod = (state: CheckoutState) =>
    REDIRECTED_PAYMENT_METHODS.has(getSelectedPaymentMethod(state));
